import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { concatMap } from 'rxjs/operators';
import { ImageUpload } from 'src/app/models/image-upload.model';
import { PrescriptionRequest } from 'src/app/models/requests/prescription-request.model';
import { PrescriptionService } from 'src/app/services/repositories/prescription.service';
import { PrescriptionPreviewComponent } from 'src/app/ui-widgets/modals/prescription-preview/prescription-preview.component';

@Component({
    selector: 'app-add-prescription',
    templateUrl: './add-prescription.component.html',
    styleUrls: ['./add-prescription.component.scss'],
    standalone: false
})
export class AddPrescriptionComponent implements OnInit {
  private readonly N_ADD_PRESCRIPTION_WARNING_TITLE = 'Add Prescription';
  private readonly N_ADD_PRESCRIPTION_WARNING_MSG = 'You must upload a prescription to continue.';

  toggleClass: boolean = true;
  prescriptionPreviewRef: NgbModalRef | undefined;
  prescriptionPreviewImage: string = '';
  isValidFile: boolean = false;
  isSubmitted: boolean = false;
  filename: string = '';
  isPDF: boolean = false;
  isPhotoReady = false;
  hasRxUploaded = false;

  acceptableRxFormats: string[] = ['application/pdf', 'image/jpeg', 'image/png'];

  private file: File | undefined;

  constructor(private _prescriptionService: PrescriptionService,
    private _modalService: NgbModal,
    private _router: Router,
    private _notificationService: ToastrService) { }

  ngOnInit(): void {
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      this.setFilename();
      this.isPhotoReady = true;
    }
  }

  onFileDrop(file: File) {
    this.file = file;
    if (this.file) {
      this.setFilename();
      this.uploadRx();
    }
  }

  setFilename() {
    if (this.file) {
      if (this.acceptableRxFormats.includes(this.file.type)) {
        this.filename = this.file.name;
        this.isValidFile = true;
        this.isPDF = this.file.type == 'application/pdf'
      } else {
        this.isValidFile = false;
      }
    }
  }

  uploadRx() {
    this.isSubmitted = true;
    if (this.file && this.isValidFile) {
      const formData = new FormData();
      formData.append('file', this.file, this.filename);
      this._prescriptionService.upload(formData).pipe(
        concatMap((uploadResult: ImageUpload) =>
          this.addNewRx(uploadResult)
        ))
        .subscribe(() => {
          this.hasRxUploaded = true;
          this.showPrescriptionImage();
        },
        (err) => {
          console.log(err.error.message);
        }
      );
    }
  }

  addNewRx(uploadResult: any) {
    const newPrescriptionImage = uploadResult.fileName;

    const prescriptionRequest: PrescriptionRequest = {
      imageName: newPrescriptionImage,
      isPendingRx: false,
    }

    if (this.isPDF) {
      prescriptionRequest.thumbnail = uploadResult.thumbnailFilename;
      this.prescriptionPreviewImage = uploadResult.thumbnailFilename;
    }

    else {
      this.prescriptionPreviewImage = newPrescriptionImage;
    }

    return this._prescriptionService.addRx(prescriptionRequest);
  }

  showPrescriptionImage() {
    const prescriptionPreviewModalRef = this._modalService.open(PrescriptionPreviewComponent,
      { modalDialogClass: '', scrollable: true, backdrop: 'static'});
      prescriptionPreviewModalRef.componentInstance.prescriptionPreviewImage = this.prescriptionPreviewImage;
      prescriptionPreviewModalRef.componentInstance.isPDF = this.isPDF;
  }

  switchPhotoStatus() {
    this.isPhotoReady = false;
  }

  finish() {
    if (this.hasRxUploaded) {
      this._router.navigate(['/sign-up/setup-complete']);
    }
    else {
      this._notificationService.warning(this.N_ADD_PRESCRIPTION_WARNING_MSG, this.N_ADD_PRESCRIPTION_WARNING_TITLE);
    }
  }

}
